export default __webpack_public_path__ + "static/media/menu.f23f81eb.svg";